import React, { useEffect, useState } from 'react';
import { listThreads, postMessage } from './api';
import { COPY } from './copy';
import MessageList from './MessageList';
import MessageComposer from './MessageComposer';

// GP-side view of a Specialist→GP request on an open issue.
// Renders the specialist's prompt, prior responses, and a composer when
// the thread is open and awaiting the GP.
const GpRequestSection = ({ issue }) => {
  const [thread, setThread] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const data = await listThreads(issue.id);
      const open = (data || []).find(
        (t) => t.direction === 'specialist_to_gp' && t.state === 'open'
      );
      setThread(open || null);
    } catch {
      // 403 / 404 — no access; hide silently
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [issue.id]);

  if (loading || !thread) return null;

  const lastAuthorRole = thread.messages?.[thread.messages.length - 1]?.author?.role;
  const awaitingGp = lastAuthorRole === 'specialist';

  const handleSubmit = async ({ body, files }) => {
    const { request_message: newMessage, thread: updatedThread } = await postMessage(
      issue.id,
      thread.id,
      { body, files }
    );
    setThread((prev) => ({
      ...prev,
      messages: [...prev.messages, newMessage],
      state: updatedThread.state,
      last_activity_at: updatedThread.last_activity_at,
    }));
  };

  return (
    <div className="bg-white rounded shadow mb-4">
      <div
        className="font-semibold uppercase text-sm text-white px-3 py-2 rounded-t"
        style={{ backgroundColor: COPY.hex.alertRed }}
      >
        {COPY.sections.additionalInformationRequested}
      </div>
      <div className="border border-t-0 border-gray-200 rounded-b p-3 bg-slate-50">
        <MessageList messages={thread.messages} />
        {awaitingGp && thread.state === 'open' && (
          <MessageComposer onSubmit={handleSubmit} />
        )}
      </div>
    </div>
  );
};

export default GpRequestSection;
